import { FC, Fragment } from "react";

interface ExistCellProps {
  data: boolean;
}

export const ExistCell: FC<ExistCellProps> = ({ data }) => {
  return <Fragment>{data ? "Available" : "Deleted"}</Fragment>;
};
